module.exports = __webpack_public_path__ + "media/bootstrap-icons/caret-left-square-ed66ffe2.svg";